import { useBootstrap } from "./useBootstrap";

/**
 * Per-district/school product toggles delivered by /bootstrap.
 *
 * Defaults match FEATURE_TOGGLE_DEFAULTS on the backend, so the app behaves
 * normally while bootstrap is still loading and for any district without a
 * feature_flags row.
 */
const DEFAULT_TOGGLES = {
  otherWellnessAction: true,
};

export function useFeatureToggles() {
  const { data: bootstrap } = useBootstrap();

  return { ...DEFAULT_TOGGLES, ...(bootstrap?.features ?? {}) };
}
